export default function Tag({ children, onRemove, selected = false, icon = null, style, onClick, ...rest }) {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: "var(--space-2)",
    fontFamily: "var(--font-body)",
    fontSize: "var(--text-sm)",
    fontWeight: "var(--weight-medium)",
    padding: "7px 14px",
    borderRadius: "var(--radius-pill)",
    cursor: onClick ? "pointer" : "default",
    background: selected ? "var(--brand)" : "var(--surface-raised)",
    color: selected ? "var(--text-on-brand)" : "var(--text-secondary)",
    border: `1px solid ${selected ? "transparent" : "var(--border-default)"}`,
    transition:
      "background var(--dur-base) var(--ease-standard), color var(--dur-base) var(--ease-standard), transform var(--dur-fast) var(--ease-spring)",
    ...style,
  };

  return (
    <span
      style={base}
      onClick={onClick}
      onMouseDown={(e) => { if (onClick) e.currentTarget.style.transform = "scale(0.95)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = ""; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = ""; }}
      {...rest}
    >
      {icon}
      {children}
      {onRemove && (
        <button
          type="button"
          aria-label="Remove"
          onClick={(e) => { e.stopPropagation(); onRemove(e); }}
          style={{ display: "inline-flex", border: "none", background: "transparent", color: "inherit", cursor: "pointer", padding: 0, opacity: 0.7 }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </span>
  );
}
